// Wrapper for DoctorsV2Api to handle the transferredToken requirement
// This is a temporary solution until the API is updated to use bearer tokens

import { DoctorsV2Api } from "../generated";
import { FileSchema } from "../../types/models/file";

export class DoctorApiWrapper {
    private api: DoctorsV2Api;
    
    constructor(api: DoctorsV2Api) {
        this.api = api;
    }

    private getTransferredToken(): string {
        // Use access_token from localStorage as the transferredToken
        return localStorage.getItem('access_token') || '';
    }
    
    async doctorSignupFacePhoto(facePhoto: FileSchema) {
        return this.api.doctorSignupFacePhoto({
            transferredToken: this.getTransferredToken(),
            facePhoto: {
                facePhoto
            }
        });
    }
    
    async doctorSignupNationalIdPhoto(nationalIdFront: FileSchema, nationalIdBack: FileSchema) {
        return this.api.doctorSignupNationalIdPhoto({
            transferredToken: this.getTransferredToken(),
            nationalIdPhoto: {
                nationalIdFront,
                nationalIdBack
            }
        });
    }
    
    async doctorSignupStep2V2(medicalLicenseFront: FileSchema, medicalLicenseBack: FileSchema) {
        return this.api.doctorSignupStep2V2({
            transferredToken: this.getTransferredToken(),
            doctorSignupStep2: {
                medicalLicenseFront,
                medicalLicenseBack
            }
        });
    }
    
    async signupStep3V2(data: {
        fullName: string;
        sex?: any;
        specialty: any;
        subSpecialty?: any;
    }) {
        return this.api.signupStep3V2({
            transferredToken: this.getTransferredToken(),
            doctorSignupStep3: data
        });
    }
    
    async signupStep4V2(data: {
        governorate?: any;
        address?: string;
        clinicLicenseNumber?: string;
        taxNumber?: string;
        clinicLicensePhoto: FileSchema;
        phoneNumber1?: string;
        phoneNumber2?: string;
    }) {
        return this.api.signupStep4V2({
            transferredToken: this.getTransferredToken(),
            doctorSignupStep4: data
        });
    }
    
    async signupStep5V2(data?: {
        clinicOutsidePhoto?: FileSchema;
        clinicInsidePhoto?: FileSchema;
    }) {
        if (data) {
            return this.api.signupStep5V2({
                transferredToken: this.getTransferredToken(),
                doctorSignupStep5: data
            });
        } else {
            return this.api.signupStep5V2({
                transferredToken: this.getTransferredToken()
            });
        }
    }
}